<template>
  <div class="activeList">
    <div
      class="conpon-list-cell"
      v-for="(item, index) in list"
      @click.prevent="handleDetailClick(item)"
      :key="index"
    >
      <div class="card">
        <div class="card-header">
          <a class="card-thumb">
            <div class="thumb-image">
              <img :src="item.imgLogoUrl" alt />
            </div>
          </a>
          <div class="card-content">
            <div class="card-title">
              <span>{{item.activityName}}</span>
              <span class="config">参与</span>
              <!-- <span class="config">{{item.activityStatus}}</span> -->
            </div>
            <div class="card-desc">{{item.activityStartDate}}-{{item.activityEndDate}}</div>
            <div class="card-bootom">
              <em>所属应用：</em>
              {{item.appName}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActiveList",
  props: {
    list: Array
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleDetailClick(item) {
      let activityId = item.activityId;
      let activityName = item.activityName;
      this.$router.push({
        path: `/activityManagement/managementDetail`,
        query: { activityId, activityName }
      });
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.activeList {
  margin-top: px2rem(10);
  background-color: #fff;
  .conpon-list-cell {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: px2rem(30);
    padding: px2rem(20) 0;
    border-bottom: px2rem(1) solid #efefef;
    .card {
      position: relative;
      box-sizing: border-box;
      color: #323233;
      font-size: px2rem(30);
      padding: px2rem(10) 0;
      .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .card-thumb {
          position: relative;
          -webkit-box-flex: 0;
          -webkit-flex: none;
          flex: none;
          width: px2rem(150);
          height: px2rem(150);
          margin-right: px2rem(40);
          .thumb-image {
            position: relative;
            display: inline-block;
            img {
              display: block;
              width: px2rem(150);
              height: px2rem(150);
            }
          }
        }
        .card-content {
          position: relative;
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -webkit-flex-direction: column;
          flex-direction: column;
          min-width: 0;
          > div {
            margin-bottom: px2rem(20);
          }
          .card-title {
            flex: 1;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .config {
              display: inline-block;
              padding: px2rem(14) px2rem(25);
              margin-left: px2rem(10);
              background-color: #0245BF !important;
              color: #fff !important;
              border-radius: px2rem(8);
              white-space: nowrap;
            }
          }
          .card-desc {
            flex: 1;
            color: #7d7e80;
          }
          .card-bootom {
            em {
              font-style: normal;
              color: #0144be;
            }
          }
        }
      }
    }
    .coupon-info-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .coupon-info-box:nth-child(2) {
      color: #bbb;
    }
    .van-card {
      padding-left: 0;
      padding-right: 0;
      background-color: #fff;
    }
  }
}
</style>